var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import Loadable from 'react-loadable';
import { useTranslation } from 'react-i18next';
import './index.scss';
import MainLayout from '../../layouts/MainLayout';
import CalendarIcon from '../../assets/icons/calendar.svg';
import { getTemplatePublisher, getTemplateUser, resetMediaInfo, resetDefaultTemplate, resetUserTemplate, storeCacheWidgetSummary, storeCacheWidgetTop3RateIncrease, storeCacheWidgetTop3RateDecrease } from '../../store/widget/actions';
import { defaultTemplateData, defaultTemplateError, isLoadingDefaultTemplate, userTemplateData, userTemplateError, isLoadingUserTemplate, mediaData, mediaError, isLoadingMedia, getCacheWDSummary, getCacheWDTop3RateIncrease, getCacheWDTop3RateDecrease } from '../../store/widget/reducer';
import * as LocalStorageUtil from '../../utils/LocalStorageUtil';
import { WD_SUMARY_CACHE_KEY, WD_TOP3_INCREASE_CACHE_KEY, WD_TOP3_DECREASE_CACHE_KEY } from '../../utils/StorageKeys';
import { resetUserInfo } from '../../store/authentication/actions';
import { userInfoData, isLoadingUserInfo } from '../../store/authentication/reducer';
import { publisherData } from '../../store/publisher/reducer';
import { resetPublisherInfo } from '../../store/publisher/actions';
import { storeCurrentMenuItemPosition } from '../../store/header/actions';
import { updateUserTemplate, updateDefaultTemplate, getMetrics, getMedias as getMediasService } from '../../services/widget-service';
import { getPlatformGroupsByLevel, getAllPlatformGroupsByLevel, getPlatforms, getPlatformsByPublisher, getDeviceCategory, getPubdeskInventories } from '../../services/report-service';
import { getLastUpdateData } from '../../services/last-update-service';
import _ from 'lodash';
import { ROLE_ADMIN, DEFAULT_TEMPLATE, USER_TEMPLATE, WIDGET_SUMMARY, ROLE_OPERATOR, ROLE_SUPER_ADMIN } from '../../utils/Constant';
import { checkRoleUser, getPublisherSelectedByCurrentUser, getCurrentUser, notificationSimple } from '../../utils/CommonUtil';
import { checkAccessMetric } from '../../utils/MetricUtil';
import { CustomDateRange } from '../../components/common/dropdown/dropdown';
import { CustomMultiSelect } from '../../components/common/multi-select-dropdown/MultiSelectDropdown';
import LastUpdate from '../../components/last-update/lastUpdate';
import { LoadingWidget, LoadingDefault } from '../../components/common/loading/loading';
import { prepareColorPlatforms } from '../../utils/ColorUtil';
import moment from "moment";
import * as Constant from "../../utils/Constant";
import { TIME_SESSION_WIDGET_SUMMARY } from "../../config/index";
import CreateIcon from '@material-ui/icons/Create';
import { getLabelSimple } from '../../services/label-service';
var DefaultTemplate = Loadable({
    loader: function () { return import('./components/DefaultTemplate'); },
    loading: function () { return React.createElement(LoadingWidget, null); },
    render: function (loaded, props) {
        var DefaultTemplate = loaded.default;
        return React.createElement(DefaultTemplate, __assign({}, props));
    }
});
var PersonalTemplate = Loadable({
    loader: function () { return import('./components/PersonalTemplate'); },
    loading: function () { return React.createElement(LoadingWidget, null); },
    render: function (loaded, props) {
        var PersonalTemplate = loaded.default;
        return React.createElement(PersonalTemplate, __assign({}, props));
    }
});
var LeftWidgets = Loadable({
    loader: function () { return import('./components/LeftWidgets'); },
    loading: function () { return React.createElement(LoadingDefault, null); },
    render: function (loaded, props) {
        var LeftWidgets = loaded.default;
        return React.createElement(LeftWidgets, __assign({}, props));
    }
});
var WidgetWrapper = Loadable({
    loader: function () { return import('./components/WidgetWrapper'); },
    loading: function () { return React.createElement(LoadingDefault, null); },
    render: function (loaded, props) {
        var WidgetWrapper = loaded.default;
        return React.createElement(WidgetWrapper, __assign({}, props));
    }
});
var Dashboard = function (props) {
    var t = useTranslation().t;
    var history = useHistory();
    var publisherSelected = getPublisherSelectedByCurrentUser();
    var _a = useState(), currentTab = _a[0], setCurrentTab = _a[1];
    var _b = useState(false), isEnableMoveDefaultWidgets = _b[0], setEnableMoveDefaultWidgets = _b[1];
    var _c = useState(false), isEnableMoveUserWidgets = _c[0], setEnableMoveUserWidgets = _c[1];
    var _d = useState(false), isEnableMoveLeftWidgets = _d[0], setEnableMoveLeftWidgets = _d[1];
    var _e = useState(false), isClickOutsideMedia = _e[0], setClickOutsideMedia = _e[1];
    var date = new Date();
    var _f = useState(), currentPublisherId = _f[0], setCurrentPublisherId = _f[1];
    var _g = useState(), fixedSummaryWidget = _g[0], setFixedSummaryWidget = _g[1];
    var _h = useState(), defaultTemplateWidgets = _h[0], setDefaultTemplateWidgets = _h[1];
    var _j = useState(), defaultLeftWidgets = _j[0], setDefaultLeftWidgets = _j[1];
    var _k = useState(), userTemplateWidgets = _k[0], setUserTemplateWidgets = _k[1];
    var _l = useState(), userLeftWidgets = _l[0], setUserLeftWidgets = _l[1];
    var _m = useState([]), medias = _m[0], setMedias = _m[1];
    var _o = useState([]), mediaSelected = _o[0], setMediaSelected = _o[1];
    var _p = useState(), metricList = _p[0], setMetricList = _p[1];
    var _q = useState(), platformList = _q[0], setPlatformList = _q[1];
    var _r = useState(), platformByPublisherList = _r[0], setPlatformByPublisherList = _r[1];
    var _s = useState(), platformGroupList = _s[0], setPlatformGroupList = _s[1];
    var _t = useState(), allPlatformGroupList = _t[0], setAllPlatformGroupList = _t[1];
    var _u = useState(), subPlatformGroupList = _u[0], setSubPlatformGroupList = _u[1];
    var _v = useState(), deviceCategoryList = _v[0], setDeviceCategoryList = _v[1];
    var _w = useState(), lastUpdateData = _w[0], setLastUpdateData = _w[1];
    var _x = useState([]), pubdeskInventories = _x[0], setPubdeskInventories = _x[1];
    var _y = useState([]), mediaNotEdit = _y[0], setMediaNotEdit = _y[1];
    var _z = useState([
        {
            startDate: new Date(date.getFullYear(), date.getMonth(), date.getDate() - 30),
            endDate: new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1),
            key: 'selection'
        }
    ]), duration = _z[0], setDuration = _z[1];
    var minDate = new Date(new Date().getFullYear() - 2, 0, 1);
    var _0 = useState([]), labelList = _0[0], setLabelList = _0[1];
    var currentUser = getCurrentUser();
    var intervalCacheWdSummary, intervalCacheWdTop3RateIncrease, intervalCacheWdTop3RateDecrease;
    var _isMounted = useRef(true);
    useEffect(function () {
        document.title = t("page.dashboard") + Constant.APP_NAME;
        setCurrentTab(getTab() ? getTab() : DEFAULT_TEMPLATE);
        getMetricList();
        getLastUpdateLabelData();
        handlePublisherSelected(publisherSelected);
        getAllPlatformList();
        props.dispatch(storeCurrentMenuItemPosition({ position: 0 }));
        sessionIntervalDashboard();
        return function () {
            _isMounted.current = false;
            clearInterval(intervalCacheWdSummary);
            setCurrentPublisherId(null);
            setMetricList([]);
            props.dispatch(resetUserInfo());
            props.dispatch(resetPublisherInfo());
            props.dispatch(resetMediaInfo());
            props.dispatch(resetDefaultTemplate());
            props.dispatch(resetUserTemplate());
        };
    }, []);
    useEffect(function () {
        if (props.publisherData && props.publisherData) {
            var publisher = getPublisherSelectedByCurrentUser();
            handlePublisherSelected(publisher);
        }
    }, [props.publisherData]);
    useEffect(function () {
        if (currentPublisherId) {
            if (currentTab === DEFAULT_TEMPLATE && !props.isLoadingDefaultTemplate) {
                getTemplateByPublisher(currentPublisherId);
            }
            else if (currentTab === USER_TEMPLATE && !props.isLoadingUserTemplate) {
                getTemplateByUser(currentPublisherId);
            }
        }
    }, [currentPublisherId]);
    useEffect(function () {
        if (currentPublisherId) {
            if (currentTab === DEFAULT_TEMPLATE && !props.defaultTemplate && !props.isLoadingDefaultTemplate) {
                getTemplateByPublisher(currentPublisherId);
                props.dispatch(resetUserTemplate());
            }
            else if (currentTab === USER_TEMPLATE && !props.userTemplate && !props.isLoadingUserTemplate) {
                getTemplateByUser(currentPublisherId);
                props.dispatch(resetDefaultTemplate());
            }
        }
    }, [currentTab]);
    useEffect(function () {
        if (props.defaultTemplate) {
            setDefaultTemplateWidgets(props.defaultTemplate);
            updateDefaultLeftWidgets(props.defaultTemplate.widgets);
            initFixedSummaryWidget(props.defaultTemplate.widgets);
        }
    }, [props.defaultTemplate]);
    useEffect(function () {
        if (defaultTemplateWidgets) {
            updateDefaultLeftWidgets(defaultTemplateWidgets);
        }
    }, [defaultTemplateWidgets]);
    var sessionIntervalDashboard = function () {
        intervalCacheWdSummary = setInterval(sessionIntervalWdSummary, TIME_SESSION_WIDGET_SUMMARY);
        intervalCacheWdTop3RateIncrease = setInterval(sessionIntervalWdTop3RateIncrease, TIME_SESSION_WIDGET_SUMMARY);
        intervalCacheWdTop3RateDecrease = setInterval(sessionIntervalWdTop3RateDecrease, TIME_SESSION_WIDGET_SUMMARY);
    };
    var sessionIntervalWdSummary = function () {
        var dataCacheWdSummary = LocalStorageUtil.getItem(WD_SUMARY_CACHE_KEY);
        if (dataCacheWdSummary) {
            props.dispatch(storeCacheWidgetSummary(true));
        }
        else {
            clearInterval(intervalCacheWdSummary);
        }
    };
    var sessionIntervalWdTop3RateIncrease = function () {
        var dataCacheWdTop3Rate = LocalStorageUtil.getItem(WD_TOP3_INCREASE_CACHE_KEY);
        if (dataCacheWdTop3Rate) {
            props.dispatch(storeCacheWidgetTop3RateIncrease(true));
        }
        else {
            clearInterval(intervalCacheWdTop3RateIncrease);
        }
    };
    var sessionIntervalWdTop3RateDecrease = function () {
        var dataCacheWdTop3Rate = LocalStorageUtil.getItem(WD_TOP3_DECREASE_CACHE_KEY);
        if (dataCacheWdTop3Rate) {
            props.dispatch(storeCacheWidgetTop3RateDecrease(true));
        }
        else {
            clearInterval(intervalCacheWdTop3RateDecrease);
        }
    };
    var getMetricList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var metrics, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setMetricList([]);
                    return [4 /*yield*/, getMetrics()];
                case 1:
                    metrics = _a.sent();
                    metrics = metrics.filter(function (metric) {
                        if (currentUser && currentUser.type === "EXTERNAL" && metric.defaultCollectionField === "payout_amount") {
                            return false;
                        }
                        if (currentUser && (currentUser.type === "EXTERNAL" || (currentUser.type === "INTERNAL" && checkRoleUser(ROLE_OPERATOR) && !checkRoleUser(ROLE_SUPER_ADMIN)))) {
                            return checkAccessMetric(metric);
                        }
                        return true;
                    });
                    metrics = _.sortBy((metrics || []), function (metric) { return metric.name; });
                    if (_isMounted.current) {
                        setMetricList(metrics);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log("Error Metric", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getAllPlatformList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var platforms, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getPlatforms(null)];
                case 1:
                    platforms = _a.sent();
                    if (_isMounted.current) {
                        platforms = _.sortBy(platforms || [], function (platform) { return platform.id; });
                        platforms = prepareColorPlatforms(platforms);
                        setPlatformList(platforms);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.log("Error Metric", error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getPlatformByPublisherList = function (publisherId) { return __awaiter(void 0, void 0, void 0, function () {
        var platforms, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getPlatformsByPublisher(publisherId)];
                case 1:
                    platforms = _a.sent();
                    if (_isMounted.current) {
                        // platforms = prepareColorPlatforms(platforms);
                        setPlatformByPublisherList(platforms);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    console.log("Error Metric", error_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getLabel = function (publisherId) { return __awaiter(void 0, void 0, void 0, function () {
        var params, labels, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    params = {
                        publisherIds: publisherId ? publisherId : "",
                    };
                    return [4 /*yield*/, getLabelSimple(params)];
                case 1:
                    labels = _a.sent();
                    if (_isMounted.current) {
                        labels = _.sortBy(labels || [], function (label) { return label.name; });
                        labels = labels.map(function (label) {
                            return {
                                value: label.id,
                                label: label.name,
                                id: label.id,
                                name: label.name,
                            };
                        });
                        console.log("🚀 ~ getLabel ~ labels:", labels);
                        setLabelList(labels);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    console.log("Error Metric", error_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getAllPlatformGroupList = function (publisherIds) { return __awaiter(void 0, void 0, void 0, function () {
        var params, platformGroups, foundSubPlatformGroup, subPlatformGroups, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    params = {
                        level: 1
                    };
                    if (publisherIds) {
                        params["publisherIds"] = publisherIds;
                    }
                    if (!_isMounted.current) return [3 /*break*/, 2];
                    setAllPlatformGroupList([]);
                    return [4 /*yield*/, getAllPlatformGroupsByLevel(params)];
                case 1:
                    platformGroups = _a.sent();
                    foundSubPlatformGroup = (platformGroups || []).find(function (platformGroup) { return platformGroup.id == 1; });
                    if (foundSubPlatformGroup) {
                        subPlatformGroups = foundSubPlatformGroup.subPlatformGroups || [];
                        subPlatformGroups = _.sortBy(subPlatformGroups, "name");
                        subPlatformGroups = subPlatformGroups.map(function (subPlatformGroup) {
                            return {
                                value: subPlatformGroup.id,
                                label: subPlatformGroup.name
                            };
                        });
                        subPlatformGroups.unshift({
                            value: "", label: "ALL"
                        });
                        setSubPlatformGroupList(subPlatformGroups);
                    }
                    setAllPlatformGroupList(platformGroups);
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    error_5 = _a.sent();
                    console.log("Error Metric", error_5);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getDeviceCategoryList = function (mediaIds, duration) { return __awaiter(void 0, void 0, void 0, function () {
        var startDate, endDate, param, deviceCategories, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    startDate = duration && duration.length
                        ? moment(duration[0].startDate).format("YYYYMMDD")
                        : "";
                    endDate = duration && duration.length ? moment(duration[0].endDate).format("YYYYMMDD") : "";
                    param = {
                        fromDate: startDate,
                        toDate: endDate
                    };
                    if (mediaIds && mediaIds.length) {
                        param["mediaIds"] = mediaIds.join();
                    }
                    return [4 /*yield*/, getDeviceCategory(param)];
                case 1:
                    deviceCategories = _a.sent();
                    if (_isMounted.current) {
                        setDeviceCategoryList(deviceCategories || []);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_6 = _a.sent();
                    console.log("Error Metric", error_6);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getPlatformGroupList = function (publisherId) { return __awaiter(void 0, void 0, void 0, function () {
        var params, platformGroups, error_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    params = {
                        publisherIds: publisherId ? publisherId : "",
                        level: 1
                    };
                    return [4 /*yield*/, getPlatformGroupsByLevel(params)];
                case 1:
                    platformGroups = _a.sent();
                    setPlatformGroupList(platformGroups);
                    return [3 /*break*/, 3];
                case 2:
                    error_7 = _a.sent();
                    console.log("Error Metric", error_7);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getLastUpdateLabelData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var lastUpdateData, error_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!checkRoleUser(ROLE_OPERATOR))
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getLastUpdateData()];
                case 2:
                    lastUpdateData = _a.sent();
                    setLastUpdateData(lastUpdateData);
                    return [3 /*break*/, 4];
                case 3:
                    error_8 = _a.sent();
                    console.log("Error Metric", error_8);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var updateDefaultLeftWidgets = function (template) {
        if (template && template.widgets && template.widgets.length) {
            var leftWidgets = template.widgets.filter(function (widget) { return widget.position === 'LEFT_PANEL'; });
            setDefaultLeftWidgets(leftWidgets);
        }
    };
    useEffect(function () {
        if (props.userTemplate) {
            setUserTemplateWidgets(props.userTemplate);
            updateUserLeftWidgets(props.userTemplate.widgets);
            initFixedSummaryWidget(props.userTemplate.widgets);
        }
    }, [props.userTemplate]);
    useEffect(function () {
        if (userTemplateWidgets) {
            updateUserLeftWidgets(userTemplateWidgets);
        }
    }, [userTemplateWidgets]);
    var updateUserLeftWidgets = function (template) {
        if (template && template.widgets && template.widgets.length) {
            var leftWidgets = template.widgets.filter(function (widget) { return widget.position === 'LEFT_PANEL'; });
            setUserLeftWidgets(leftWidgets);
        }
    };
    var initFixedSummaryWidget = function (widgets) {
        if (!fixedSummaryWidget && widgets && widgets.length) {
            var summaryWidget = widgets.find(function (item) { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.widget) === null || _a === void 0 ? void 0 : _a.code) === WIDGET_SUMMARY; });
            setFixedSummaryWidget(summaryWidget);
        }
    };
    var getTab = function () {
        if (props.location && props.location.search) {
            return props.location.search.substring(1).split("=")[1];
        }
    };
    var handlePublisherSelected = function (publisher) {
        setMediaSelected([]); //change publisher to defaul media
        setMediaNotEdit([]);
        if (publisher) {
            var publisherId = publisher.id;
            setCurrentPublisherId(publisherId);
            getMediaByPublisher(publisherId);
            getPlatformGroupList(publisherId);
            getPlatformByPublisherList(publisherId);
            getAllPlatformGroupList(publisherId);
            getLabel(publisherId);
        }
        else {
            getPlatformGroupList(null);
            getAllPlatformGroupList();
        }
    };
    var getTemplateByPublisher = function (publisherId) {
        props.dispatch(getTemplatePublisher(publisherId));
    };
    var getTemplateByUser = function (publisherId) {
        props.dispatch(getTemplateUser(publisherId));
    };
    var getMediaByPublisher = function (publisherId) { return __awaiter(void 0, void 0, void 0, function () {
        var params, dataMedias, mediaClone, errorMedias_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    params = {
                        publisherIds: publisherId
                    };
                    return [4 /*yield*/, getMediasService(params)];
                case 1:
                    dataMedias = _a.sent();
                    setMediaNotEdit(dataMedias);
                    mediaClone = _.cloneDeep(dataMedias);
                    buildMediaList(mediaClone, function (mediaSelected) {
                        var mediaIds = (mediaSelected || []).map(function (media) { return media.id; });
                        fetchPubdeskInventories(publisherId, mediaIds.join());
                        getDeviceCategoryList(mediaIds, duration);
                    });
                    return [3 /*break*/, 3];
                case 2:
                    errorMedias_1 = _a.sent();
                    console.log("Error get Media List", errorMedias_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchPubdeskInventories = function (publisherIds, mediaIds) { return __awaiter(void 0, void 0, void 0, function () {
        var inventories, error_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setPubdeskInventories([]);
                    return [4 /*yield*/, getPubdeskInventories(publisherIds, mediaIds)];
                case 1:
                    inventories = _a.sent();
                    inventories = _.sortBy((inventories || []), function (option) { return option.name; });
                    setPubdeskInventories(inventories);
                    return [3 /*break*/, 3];
                case 2:
                    error_9 = _a.sent();
                    console.error('fetchPlatformInventories:', error_9);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var buildMediaList = function (mediaList, callbackMediaSelected) {
        if (mediaList && mediaList.length) {
            setMedias([]);
            var medias_1 = _.sortBy(mediaList, "name");
            var mediaLocalStore = LocalStorageUtil.getItem(LocalStorageUtil.CURRENT_MEDIA);
            if (medias_1 && medias_1.length && mediaLocalStore) {
                var currentMedias = JSON.parse(mediaLocalStore);
                if (currentMedias && currentMedias.length) {
                    if (currentMedias[0].publisher && medias_1[0].publisher && currentMedias[0].publisher.id == medias_1[0].publisher.id) {
                        var selectedMedias = currentMedias.filter(function (media) {
                            var findIndex = medias_1.findIndex(function (item) { return item && item.id == media.id; });
                            return findIndex > -1 ? true : false;
                        });
                        setMediaSelected(selectedMedias);
                        callbackMediaSelected(selectedMedias);
                        setMedias(medias_1);
                        return;
                    }
                }
            }
            setMediaSelected(medias_1);
            callbackMediaSelected(medias_1);
            LocalStorageUtil.storeItem(LocalStorageUtil.CURRENT_MEDIA, JSON.stringify(medias_1));
            setMedias(medias_1);
        }
    };
    var onUpdateTemplate = function (template, templateType, actionType, leftWidgetDataUpdate) {
        if (leftWidgetDataUpdate === void 0) { leftWidgetDataUpdate = null; }
        if (template && template.widgets) {
            if (templateType === DEFAULT_TEMPLATE) {
                var leftWidgets = defaultLeftWidgets === null || defaultLeftWidgets === void 0 ? void 0 : defaultLeftWidgets.map(function (item) {
                    return {
                        id: item.id,
                        // displayType: item.displayType ? item.displayType : "FULL",
                        widgetId: item.widget.id,
                        position: item.position,
                        order: item.order
                    };
                });
                if (leftWidgetDataUpdate) {
                    var index = leftWidgets === null || leftWidgets === void 0 ? void 0 : leftWidgets.findIndex(function (item) { return item.id === leftWidgetDataUpdate.id; });
                    leftWidgets[index].setting = leftWidgetDataUpdate.setting;
                }
                template.widgets = _.concat(template.widgets, leftWidgets);
                updateDefaultTemplate(template).then(function (response) {
                    setDefaultTemplateWidgets(response);
                    if (actionType == Constant.DEFAULT_VIEW_ACTION) {
                        notificationSimple("Save Default View Widget Success!", Constant.NOTIFICATION_SUCCESS);
                    }
                });
            }
            else if (templateType === USER_TEMPLATE) {
                var leftWidgets = userLeftWidgets === null || userLeftWidgets === void 0 ? void 0 : userLeftWidgets.map(function (item) {
                    return {
                        id: item.id,
                        // displayType: item.displayType ? item.displayType : "FULL",
                        widgetId: item.widget.id,
                        position: item.position,
                        order: item.order
                    };
                });
                if (leftWidgetDataUpdate) {
                    var index = leftWidgets === null || leftWidgets === void 0 ? void 0 : leftWidgets.findIndex(function (item) { return item.id === leftWidgetDataUpdate.id; });
                    leftWidgets[index].setting = leftWidgetDataUpdate.setting;
                }
                template.widgets = _.concat(template.widgets, leftWidgets);
                updateUserTemplate(template).then(function (response) {
                    setUserTemplateWidgets(response);
                    if (actionType == Constant.DEFAULT_VIEW_ACTION) {
                        notificationSimple("Save Default View Widget Success!", Constant.NOTIFICATION_SUCCESS);
                    }
                });
            }
        }
    };
    var onClickTab = function (tab) {
        setCurrentTab(tab);
    };
    var onClickMoveButton = function () {
        if (currentTab === DEFAULT_TEMPLATE) {
            if (checkDisplayDefaultTab()) {
                setEnableMoveDefaultWidgets(!isEnableMoveDefaultWidgets);
            }
        }
        else if (currentTab === USER_TEMPLATE) {
            setEnableMoveUserWidgets(!isEnableMoveUserWidgets);
        }
    };
    var checkDisplayDefaultTab = function () {
        if (currentUser && currentUser.type == "INTERNAL" && (checkRoleUser(ROLE_OPERATOR) || checkRoleUser(ROLE_SUPER_ADMIN))) {
            return true;
        }
        if (currentUser && currentUser.type === "EXTERNAL" && checkRoleUser(ROLE_ADMIN)) {
            return true;
        }
        return false;
    };
    var onSelectedMedia = function (medias) {
        setClickOutsideMedia(false);
        if (_.isEqual(mediaSelected, medias)) {
            return;
        }
        setMediaSelected(medias);
        var mediaIds = (medias || []).map(function (media) { return media.id; });
        fetchPubdeskInventories(currentPublisherId, mediaIds.join());
        getDeviceCategoryList(mediaIds, duration);
        LocalStorageUtil.storeItem(LocalStorageUtil.CURRENT_MEDIA, JSON.stringify(medias));
    };
    var onUpdateDuration = function (duration) {
        setDuration(duration);
        var mediaIds = (mediaSelected || []).map(function (media) { return media.id; });
        getDeviceCategoryList(mediaIds, duration);
    };
    var onClickOutsideMedia = function () {
        setClickOutsideMedia(true);
    };
    return (React.createElement(MainLayout, null,
        React.createElement("div", { className: "layout-static" },
            React.createElement("div", { className: "static-content-wrapper" },
                React.createElement("div", { className: "static-content" },
                    React.createElement("div", { className: "page-content page-publishers" },
                        React.createElement("div", { className: "container-fluid container-dashboard" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "dashboard-top" },
                                    React.createElement("div", null, checkRoleUser(ROLE_OPERATOR) ? React.createElement(LastUpdate, { label: "*" + t("common.last_update_label"), lastUpdate: lastUpdateData && lastUpdateData.updatedDate ? lastUpdateData.updatedDate : "" }) : null),
                                    React.createElement("div", null,
                                        React.createElement(CustomMultiSelect, { defaultText: t("common.media_switching"), defaults: mediaSelected, options: medias, validationChecked: true, clickOutside: isClickOutsideMedia, onClickOutside: onClickOutsideMedia, onBlur: onSelectedMedia }))),
                                React.createElement(Grid, { container: true, spacing: 3 },
                                    React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                                        React.createElement("div", { className: 'flex justify-space-between' },
                                            React.createElement("h3", { className: "title-left-widget" }, t('dashboard.left_title')),
                                            (currentTab === DEFAULT_TEMPLATE && checkDisplayDefaultTab()) || currentTab === USER_TEMPLATE ?
                                                React.createElement("button", { className: "btn-no-border", type: "button", onClick: function () { return setEnableMoveLeftWidgets(!isEnableMoveLeftWidgets); } },
                                                    React.createElement(CreateIcon, { style: { color: isEnableMoveLeftWidgets ? "#2F80ED" : "" } }))
                                                : null),
                                        React.createElement(LeftWidgets, { templateData: defaultTemplateData, publisherId: currentPublisherId, data: currentTab === DEFAULT_TEMPLATE ? defaultTemplateWidgets : userTemplateWidgets, widgets: currentTab === DEFAULT_TEMPLATE ? defaultLeftWidgets : userLeftWidgets, metrics: metricList, medias: mediaSelected, mediaList: medias, mediaNotEdits: mediaNotEdit, cacheWidgetTop3RateIncrease: props.cacheWidgetTop3RateIncrease, cacheWidgetTop3RateDecrease: props.cacheWidgetTop3RateDecrease, dispatch: props.dispatch, onUpdateTemplate: function (template, templateType, leftWidgetDataUpdate) { return onUpdateTemplate(template, templateType, "", leftWidgetDataUpdate); }, isShowSetting: isEnableMoveLeftWidgets, currentTab: currentTab })),
                                    React.createElement(Grid, { item: true, xs: 12, sm: 9 },
                                        React.createElement("div", { className: "fixed-widget" },
                                            React.createElement(WidgetWrapper, { data: fixedSummaryWidget, dispatch: props.dispatch, cacheWidgetSummary: props.cacheWidgetSummary, metrics: metricList, index: 0, isAllowDrag: false, medias: mediaSelected, widgetType: WIDGET_SUMMARY, deviceCategories: deviceCategoryList })),
                                        React.createElement(Grid, { container: true, direction: "row", justify: "space-between", alignItems: "center", className: "button-controls", spacing: 1 },
                                            React.createElement(Grid, { item: true },
                                                React.createElement(Link, { to: '/dashboard?tab=DEFAULT' },
                                                    React.createElement("button", { type: "button", onClick: function () { return onClickTab(DEFAULT_TEMPLATE); }, className: "btn btn-default btn-tab-template" + (currentTab === DEFAULT_TEMPLATE ? ' btn-tab-template-selected' : '') },
                                                        React.createElement("span", null, t('dashboard.default')))),
                                                React.createElement(Link, { to: '/dashboard?tab=ACCOUNT' },
                                                    React.createElement("button", { type: "button", onClick: function () { return onClickTab(USER_TEMPLATE); }, className: "btn btn-default btn-tab-template" + (currentTab === USER_TEMPLATE ? ' btn-tab-template-selected' : '') },
                                                        React.createElement("span", null, t('dashboard.account'))))),
                                            React.createElement(Grid, { item: true, className: "right-controls" },
                                                (currentTab === DEFAULT_TEMPLATE && checkDisplayDefaultTab()) || currentTab === USER_TEMPLATE ?
                                                    React.createElement("button", { className: "btn-no-border", type: "button", onClick: onClickMoveButton },
                                                        React.createElement(CreateIcon, { style: { color: isEnableMoveDefaultWidgets ? "#2F80ED" : "" } }))
                                                    : null,
                                                React.createElement(CustomDateRange, { duration: duration, onSelect: onUpdateDuration, icon: CalendarIcon, showDropdown: false, maxDate: date, minDate: minDate }))),
                                        React.createElement("div", { className: "default-template" + (currentTab === DEFAULT_TEMPLATE ? ' display-block' : ' display-none') },
                                            React.createElement(DefaultTemplate, { data: defaultTemplateWidgets, publisherId: currentPublisherId, duration: duration[0], metrics: metricList, medias: mediaSelected, platformByPublishers: platformByPublisherList, platforms: platformList, platformGroups: platformGroupList, allPlatformGroups: allPlatformGroupList, subPlatformGroups: subPlatformGroupList, isEnableMoveWidget: isEnableMoveDefaultWidgets, deviceCategories: deviceCategoryList, inventories: pubdeskInventories, dispatch: props.dispatch, labelList: labelList, onUpdateTemplate: function (template, templateType, actionType) { return onUpdateTemplate(template, templateType, actionType); } })),
                                        React.createElement("div", { className: "user-template" + (currentTab === USER_TEMPLATE ? ' display-block' : ' display-none') },
                                            React.createElement(PersonalTemplate, { data: userTemplateWidgets, publisherId: currentPublisherId, duration: duration[0], medias: mediaSelected, metrics: metricList, platforms: platformList, platformByPublishers: platformByPublisherList, platformGroups: platformGroupList, allPlatformGroups: allPlatformGroupList, subPlatformGroups: subPlatformGroupList, isEnableMoveWidget: isEnableMoveUserWidgets, deviceCategories: deviceCategoryList, inventories: pubdeskInventories, dispatch: props.dispatch, labelList: labelList, onUpdateTemplate: function (template, templateType, actionType) { return onUpdateTemplate(template, templateType, actionType); } }))))))))))));
};
function mapStateToProps(state) {
    return {
        defaultTemplate: defaultTemplateData(state),
        defaultTemplateError: defaultTemplateError(state),
        isLoadingDefaultTemplate: isLoadingDefaultTemplate(state),
        userTemplate: userTemplateData(state),
        userTemplateError: userTemplateError(state),
        isLoadingUserTemplate: isLoadingUserTemplate(state),
        userInfoData: userInfoData(state),
        isLoadingUserInfo: isLoadingUserInfo(state),
        mediaList: mediaData(state),
        mediaError: mediaError(state),
        isLoadingMedia: isLoadingMedia(state),
        publisherData: publisherData(state),
        cacheWidgetSummary: getCacheWDSummary(state),
        cacheWidgetTop3RateIncrease: getCacheWDTop3RateIncrease(state),
        cacheWidgetTop3RateDecrease: getCacheWDTop3RateDecrease(state)
    };
}
export default connect(mapStateToProps)(Dashboard);
